import React from 'react';
import Gryffindor from './gryff.png';
import Hufflepuff from './Huf.jpg';
import Ravenclaw from './Rav.jpg';
import Slytherin from './Sly.jpg';

class Profile extends React.Component{
    constructor() {
        super();
        this.state={
            Logo: '',
            HouseInfo: '',
        }
    }

    componentDidMount(){
        if (this.props.house==="Gryffindor") {
            this.setState({Logo: Gryffindor,HouseInfo:
            'Gryffindor values courage, bravery, nerve, and chivalry.You are destined to be great and are so brave that you were soted into Gryffindor'})
        } else if (this.props.house==="Hufflepuff") {
            this.setState({Logo: Hufflepuff,HouseInfo:
            'Hufflepuff values hard work, patience, justice, and loyalty.Being Noble and Loyal You have been sorted into Hufflepuff'})
        } else if (this.props.house==="Ravenclaw") {
            this.setState({Logo: Ravenclaw,HouseInfo:
            'Ravenclaw values intelligence, learning, wisdom and wit.You are intelligent enough to be chosen as a Ravenclaw '})
        } else{
            this.setState({Logo: Slytherin,HouseInfo:
            'Slytherin values ambition, cunning, leadership, and resourcefulness.You are an ambitious one and will everything in your power to gain what you want.'})
        }
    }

    render(){
        const {name,email,joined,house,onRouteChange}= this.props;
        return(
            <div className="u-center-text potter__self">
                <div className = {`Logo`} options = {{max: 150}}>
                    <div className="Logo-inner pa3">
                        <img src= {this.state.Logo} alt = "House img" />
                    </div>
                </div>
                <div className="potter__self--know">
                    <h1 className="mt6">Name: {name}</h1>
                    <h1>Email: {email}</h1>
                    <h1>Joined: {joined}</h1>
                    <h1>House: {house}</h1>
                    <p className="f3 link dim pointer mt3 b--black ba" onClick={()=>onRouteChange('home')}>Back</p>
                </div>
                <p className="potter__self--House">{this.state.HouseInfo}</p>
            </div>
        )
    }
}

export default Profile